import { FC, Fragment, MouseEventHandler, ReactNode, useState } from "react";
import cn from "classnames";
import { Button } from "@crowd/ui-kit";
import { useDispatch } from "react-redux";
import Loader from "../../../presentational/Loaders/Loader/Loader";
import EventsTrackWrapperClick from "../../EventsTrack/wrappers/EventsTrackWrapperClick";
import AppModal, { AppModalProps } from "../AppModal/AppModal";
import { showErrorToast } from "../../../../store/actions/ToastActions";

export interface ConfirmModalProps
  extends Omit<AppModalProps, "blockScroll" | "children"> {
  isLoading?: boolean;
  title?: string;
  body?: ReactNode;
  onConfirm?: () => void | Promise<void>;
  confirmBtnText?: string;
  cancelBtnText?: string;
  dontCloseOnConfirm?: boolean;
  inConfirmBtnOutlined?: boolean;
  canConfirm?: boolean | (() => boolean);
}

const ConfirmModal: FC<ConfirmModalProps> = ({
  onClose,
  title,
  body,
  confirmBtnText,
  cancelBtnText,
  isLoading,
  onConfirm,
  canConfirm,
  dontCloseOnConfirm = false,
  inConfirmBtnOutlined = false,
  ...otherProps
}) => {
  const dispatch = useDispatch();
  const [isConfirming, setIsConfirming] = useState(false);

  const confirmHandler: MouseEventHandler = async () => {
    setIsConfirming(true);
    try {
      await onConfirm?.();
      !dontCloseOnConfirm && onClose();
    } catch (e: any) {
      dispatch(showErrorToast(e.message));
      // eslint-disable-next-line no-console
      console.log(e);
    } finally {
      setIsConfirming(false);
    }
  };

  const confirmText = confirmBtnText || "Отправить";
  return (
    <AppModal blockScroll onClose={onClose} {...otherProps}>
      {isLoading ? (
        <Fragment key="body">
          <Loader />
        </Fragment>
      ) : (
        [
          !!title && (
            <Fragment key="header">
              <span className={cn({ disabled: isConfirming })}>{title}</span>
            </Fragment>
          ),

          <Fragment key="body">
            <div className={cn({ disabled: isConfirming })}>{body}</div>
          </Fragment>,

          <Fragment key="footer">
            {!!cancelBtnText && (
              <Button
                size="l"
                type="outlined-grey"
                text={cancelBtnText}
                onClick={onClose}
              />
            )}
            <EventsTrackWrapperClick id={196} replace={[confirmText]}>
              <Button
                size="l"
                type={inConfirmBtnOutlined ? "outlined" : "filled"}
                text={confirmText}
                isLoading={isConfirming}
                onClick={confirmHandler}
                isDisabled={
                  typeof canConfirm === "boolean"
                    ? !canConfirm
                    : (canConfirm && !canConfirm()) || false
                }
              />
            </EventsTrackWrapperClick>
          </Fragment>,
        ]
      )}
    </AppModal>
  );
};

export default ConfirmModal;
